import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Area } from 'OpsCenter/merchant-tools/models/area';
import { MigrationRequest } from 'OpsCenter/merchant-tools/models/migration-request';
import { MerchantToolType } from 'OpsCenter/merchant-tools/models/merchant-tool-type';

@Component({
  selector: 'app-migration-form',
  template: require('./migration-form.component.html'),
  styles: [require('./migration-form.component.scss')],
})

export class MigrationFormComponent implements OnInit {
  @Input() merchant: any;
  @Input() areas: Area[];
  @Input() currentMigrationType: MerchantToolType;
  @Input() requestedSuccessfully;
  @Input() tables;


  @Output() onFormSubmit = new EventEmitter<MigrationRequest>();
  @Output() errorOccurred = new EventEmitter<string>();
  @Output() onAreaSelected = new EventEmitter<number>();

  public form: FormGroup;
  private datePattern = '^(0[1-9]|[12][0-9]|3[01])[.](0[1-9]|1[012])[.](19|20)\\d\\d$';
  private migrationType = MerchantToolType;

  constructor(private formBuilder: FormBuilder) {
  }

  ngOnInit(): void {
    this.form = this.buildForm();
  }

  public onSubmitClick() {
    if (this.currentMigrationType === MerchantToolType.AREA_MIGRATION &&
      this.form.controls.selectedSourceAreaId.value === this.form.controls.selectedDestinationAreaId.value) {
      this.errorOccurred.emit('You selected same area for source and destination. Please select different areas.');
    } else if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.errorOccurred.emit('You have invalid fields in the form. Please fix them and try again');
    } else {
      const requestBody = this.getRequestBody();
      this.onFormSubmit.emit(requestBody);
    }
  }

  private onAreaSourceSelected(areaId: number): void {
    if (areaId) {
      this.onAreaSelected.emit(areaId);
    }
  }

  private getRequestBody(): MigrationRequest {
    const { start, end } = this.formatDates();
    if (this.currentMigrationType === this.migrationType.AREA_MIGRATION) {
      return {
        end,
        fromAreaId: this.form.controls.selectedSourceAreaId.value,
        start,
        toAreaId: this.form.controls.selectedDestinationAreaId.value,
      };
    }
    return {
      end,
      fromTableId: this.form.controls.selectedTableId.value,
      start,
      toAreaId: this.form.controls.selectedDestinationAreaId.value,
    };
  }

  private formatDates(): any {
    const end = moment(this.form.controls.endDate.value, 'DD.MM.YYYY').format('YYYY-MM-DD');
    const start = moment(this.form.controls.startDate.value, 'DD.MM.YYYY').format('YYYY-MM-DD');

    return { start, end };
  }

  private buildForm(): any {
    const selectedTableValidators = this.currentMigrationType === this.migrationType.AREA_MIGRATION ? null : [Validators.required];
    return this.formBuilder.group({
      selectedSourceAreaId: ['', [Validators.required]],
      selectedDestinationAreaId: ['', [Validators.required]],
      selectedTableId: ['', selectedTableValidators],
      startDate: ['', [Validators.required, Validators.pattern(this.datePattern)]],
      endDate: ['', [Validators.required, Validators.pattern(this.datePattern)]],
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/merchant-tools/migration-form/migration-form.component.ts